// Form 19 Supplier List Fetch Endpoint Fix Updated: 2026-08-24 17:02
/* eslint-disable quotes */
import React, { useState, useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import {
  Table, Button, Input, Typography, message, Tooltip, Popconfirm, Tag, Icon, Divider, Dropdown, Menu
} from 'antd';
import moment from 'moment';
import { platformApi } from '../../../api';
import { ContextAPI } from '../../../ContextAPI';
import Form19Modal from './Form19Modal';

const { Search } = Input;
const { Title } = Typography;

const Form19 = (props) => {
  const [limit, setLimit] = useState(10);
  const [dataSource, setDataSource] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalValues, setModalValues] = useState(null);
  const [modalMode, setModalMode] = useState('create'); // 'create' | 'edit' | 'view'
  const [count, setCount] = useState(0);
  const [search, setSearch] = useState('');

  const [createAccess, setCreateAccess] = useState(true);
  const [modifyAccess, setModifyAccess] = useState(true);
  const [deleteAccess, setDeleteAccess] = useState(true);

  const { loginCredintials } = useContext(ContextAPI);

  const getMenu = () => {
    let size = Math.ceil(count / limit) || 1;
    const menus = [10];
    size = size <= 10 ? size : 10;
    for (let itr = 2; itr <= size; itr++) menus.push(itr * 10);
    return menus.map((menu) => (
      <Menu.Item onClick={() => setLimit(menu)} key={menu}>
        {menu}
      </Menu.Item>
    ));
  };

  const menu = <Menu>{getMenu()}</Menu>;

  useEffect(() => {
    if (loginCredintials && loginCredintials.roleAccess) {
      loginCredintials.roleAccess.forEach((each) => {
        const sub = (each.subModule || '').toLowerCase().replace(/_/g, ' ').trim();
        if (sub === 'form 19' || sub === 'form19') {
          if (each.access) {
            setCreateAccess(!!each.access.create);
            setModifyAccess(!!each.access.update);
            setDeleteAccess(!!each.access.delete);
          }
        }
      });
    }
    fetchForm19List();
  }, [loginCredintials]);

  useEffect(() => {
    fetchForm19List(search);
  }, [search, limit]);

  const fetchForm19List = (searchTerm = '') => {
    setTableLoading(true);
    platformApi
      .get('/api/form-19', { params: { search: searchTerm } })
      .then((res) => {
        const data = res.data;
        if (data && data.code === 200) {
          const list = data.data || [];
          setDataSource(list);
          setCount(data.count !== undefined ? data.count : list.length);
        } else {
          message.error(data?.message || 'Failed to fetch Form 19 records');
        }
      })
      .catch((err) => {
        console.error('Fetch Form 19 Error:', err);
        message.error('Error fetching Form 19 list');
      })
      .finally(() => {
        setTableLoading(false);
      });
  };

  const handleDelete = (id) => {
    setTableLoading(true);
    platformApi
      .delete(`/api/form-19/${id}`)
      .then((res) => {
        if (res.data && res.data.code === 200) {
          message.success('Form 19 record deleted successfully');
          fetchForm19List(search);
        } else {
          message.error(res.data?.message || 'Failed to delete Form 19 record');
          setTableLoading(false);
        }
      })
      .catch((err) => {
        console.error('Delete Form 19 Error:', err);
        message.error('Server error deleting Form 19 record');
        setTableLoading(false);
      });
  };

  const columns = [
    {
      title: 'Dealer Name',
      dataIndex: 'dealerName',
      key: 'dealerName',
      render: (text, record) => text || record.Supplier?.name || 'N/A'
    },
    {
      title: 'TC / Registered Numbers',
      dataIndex: 'tcNumbers',
      key: 'tcNumbers',
      render: (tcNumbers) => {
        if (!tcNumbers || !Array.isArray(tcNumbers) || tcNumbers.length === 0) {
          return 'N/A';
        }
        return (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
            {tcNumbers.map((tag) => (
              <Tag
                key={tag}
                style={{
                  backgroundColor: '#6c757d',
                  color: '#ffffff',
                  fontWeight: '500',
                  borderRadius: '3px'
                }}
              >
                {tag}
              </Tag>
            ))}
          </div>
        );
      }
    },
    {
      title: 'Expiry Date',
      dataIndex: 'expiryDate',
      key: 'expiryDate',
      width: 150,
      render: (date) => (date ? moment(date).format('DD/MM/YYYY') : 'N/A')
    },
    {
      title: 'Action',
      key: 'action',
      width: 180,
      render: (_, record) => (
        <div onClick={(e) => e.stopPropagation()}>
          {modifyAccess ? (
            <span
              onClick={() => {
                setModalValues(record);
                setModalMode('edit');
                setModalVisible(true);
              }}
              className="linkylink"
              style={{ color: '#1890ff', cursor: 'pointer' }}
            >
              Modify
            </span>
          ) : null}
          {deleteAccess ? (
            <Popconfirm
              title="Do you want to delete this Form 19 record?"
              onConfirm={() => handleDelete(record.id)}
              okText="Yes"
              cancelText="No"
              onCancel={(e) => e.stopPropagation()}
            >
              <span
                onClick={(e) => e.stopPropagation()}
                className="linkylink"
                style={{ color: '#1890ff', cursor: 'pointer' }}
              >
                {modifyAccess ? <Divider type="vertical" /> : null}
                Delete
              </span>
            </Popconfirm>
          ) : null}
        </div>
      )
    }
  ];

  return (
    <div style={{ padding: '20px' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          marginBottom: '1.25rem'
        }}
      >
        <Title style={{ width: '60%', margin: 0, display: 'flex', alignItems: 'center' }} level={4}>
          <Tooltip placement="topLeft" title="Back to Company Master">
            <Button
              style={{ margin: '0 20px 0 0' }}
              onClick={() => props.history.push('/autoadmin/company')}
            >
              <Icon type="left" />
            </Button>
          </Tooltip>
          Form 19 [{count}]
          <span style={{ marginLeft: '1rem' }}>
            <Dropdown overlay={menu} trigger={['click']}>
              <Button>
                {limit}
                &nbsp;
                <Icon type="down" />
              </Button>
            </Dropdown>
          </span>
        </Title>

        <Search
          style={{ width: '30%' }}
          placeholder="Search Form 19"
          allowClear
          onSearch={(val) => setSearch(val)}
          onChange={(e) => {
            if (!e.target.value) setSearch('');
          }}
        />

        <Button
          onClick={() => {
            setModalValues(null);
            setModalMode('create');
            setModalVisible(true);
          }}
          style={{ margin: '0 3%', width: '20%' }}
          type="primary"
          disabled={!createAccess}
        >
          Add Form 19
        </Button>
      </div>

      <Table
        rowKey="id"
        columns={columns}
        dataSource={dataSource}
        loading={tableLoading}
        style={{ cursor: 'pointer' }}
        onRow={(record) => ({
          onClick: () => {
            setModalValues(record);
            setModalMode('view');
            setModalVisible(true);
          }
        })}
        pagination={{
          pageSize: limit,
          showQuickJumper: true,
          showTotal: (total) => `Total ${total} items`
        }}
      />

      <Form19Modal
        open={modalVisible}
        close={() => setModalVisible(false)}
        values={modalValues}
        mode={modalMode}
        onSuccess={() => fetchForm19List(search)}
      />
    </div>
  );
};

export default withRouter(Form19);
